var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex" }, [
      _vm.currentBooking.booked_as_guest == "Yes"
        ? _c(
            "a",
            {
              staticClass:
                "btn btn-primary text-white d-flex align-items-center justify-content-center mb-3",
              on: { click: _vm.showUserSelector }
            },
            [_vm._v("\n            Link to Customer")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "user-search", role: "dialog" }
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content tx-size-sm" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body pd-y-20 pd-x-20" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Email:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "email" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "border-0 modal-footer pt-0" }, [
              _c(
                "button",
                {
                  staticClass: "btn ripple btn-primary pd-x-25",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.link }
                },
                [_vm._v("\n                        Link\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn ripple btn-light pd-x-25 ml-3",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [
                  _vm._v(
                    "\n                        Close\n                    "
                  )
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Please select a user")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }